module.exports = __webpack_public_path__ + "img/bg1.e0873237.png";